import React, {useContext} from 'react';
import 'styles/settings/Swag.css';
import UniversalEmptyPageHeader from 'components/universal/UniversalEmptyPageHeader';
import {UserContext} from 'components/user/UserContext';

const PageRules = () => {
    const {isCashTenant} = useContext(UserContext);

    return (
        <div>
            <UniversalEmptyPageHeader text={'Rules'} image={'logo'}/>
            <div style={{display: 'flex', width: '100%'}}>
                <div className="main-content-body-padding">{
                    isCashTenant ? (
                        <>

                        </>
                    ) : (
                        <>
                            <h2 style={{marginTop: 0, color: '#10450e'}}>Donation Rules</h2>
                            <p>Link has to point to official web of charity acknowledged by BLA BLA.</p>
                            <p>Upon opening link, badge and amount has to be searchable on the page.</p>
                            <p>Maximum donation is 250$. This number can change over time.</p>
                            <p>Charity must have rating at least 4.5 on page BLA BLA.</p>
                            <p>We are not obliged to approve or decide on charity link even when all the conditions
                                above are fulfilled.</p>
                            <p>We do not receive any provision or return favor from charity donations,
                                but we have <a href="https://www.flexagren.com/swag">swag</a>.</p>
                        </>
                    )

                }
                    <h2 style={{marginTop: 0, color: '#10450e'}}>Page Rules</h2>
                    <p>All content has to be language independent or in english language.</p>
                    <p>No advertisement or promotional content, including non-profit organizations.</p>
                    <p>No personal or contact information, links to other pages.</p>
                    <p>No strongly political content, especially display or promotion of person convicted in Hague.</p>
                    <p>No spam or meaningless content.</p>
                    <p>No NSFW, adult, 18+ or illegal content.</p>
                    <p>No content that promotes hate, violence, racism, discrimination or harm towards individuals
                        or groups.</p>
                    <p>No impersonation or false information.</p>
                    <p>No automated bot content.</p>
                    <p>We might edit remove any content with or without refund to account, even when no rules are
                        violated.</p>
                    <p>We can keep content that violates the rules.</p>
                    <p>User can be prompted to pick nickname again, or nickname might be changed without user
                        approval.</p>
                </div>
            </div>
        </div>
    );
};

export default PageRules;